import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { getCalendarLocations } from '../../actions.js';
import { Helmet } from 'react-helmet';
import kecko from '../../../assets/kecko.png';

class CalendarOverview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    CalendarOverview.init(this.props.dispatch).catch(() => {});
  }

  static init(dispatch) {
    return dispatch(getCalendarLocations());
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>Kalendár - zvoľte mesto</title>
          <meta
            property="og:description"
            content="Zvoľte mesto, ktorého kalendár udalostí si chcete prezrieť"
          />
          <meta property="og:image" content={kecko} />
        </Helmet>

        <div className="bg-alt-light article-header">
          <div className="container">
            <div className="article-header-title">
              <h1>Kalendár - zvoľte mesto</h1>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="section">
            <div className="row">
              {this.props.calendarLocations.map(item => {
                return (
                  <div className="col-sm-4 col-xs-6 col-md-3 col-lg-2">
                    <Link
                      key={item._id}
                      className="btn btn-primary btn-block"
                      style={{ margin: '5px' }}
                      to={`/calendar/${item._id}`}
                    >
                      {item.name}
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CalendarOverview.fetchData = ({ store, location, params }) => {
  return Promise.resolve(CalendarOverview.init());
};

CalendarOverview.propTypes = {
  dispatch: PropTypes.func.isRequired,
  calendarLocations: PropTypes.array.isRequired,
};

export default connect(state => {
  return {
    calendarLocations: state.calendar.locations,
  };
})(CalendarOverview);



// WEBPACK FOOTER //
// ./src/app/container/calendar/calendar-overview.js